import { basicInitialState } from '../_utils/basicInitialState';
import { TPeopleState } from './people';

export const peopleInitialState: TPeopleState = {
  ...basicInitialState,
  people: null,
  searchText: ''
};
